module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/chevron-carousel-next-pc-589ad3b0738cb0655eb4801fc24d2ea6.svg";